import { useEffect, useState } from 'react';
import api from './api';

export const logoUrl = (kind, version) =>
  version ? `${process.env.REACT_APP_BACKEND_URL}/api/public/logo/${kind}?v=${encodeURIComponent(version)}` : null;

export function useBrandLogos() {
  const [info, setInfo] = useState({});

  useEffect(() => {
    let mounted = true;
    api.get('/public/group-info').then(res => { if (mounted) setInfo(res.data || {}); }).catch(() => {});
    return () => { mounted = false; };
  }, []);

  return {
    info,
    groupLogo: logoUrl('group', info.group_logo_version),
    companyLogo: logoUrl('company', info.company_logo_version),
  };
}
